import type { Feature, FeatureGroup } from '../types';
import { ALL_ADMINISTRATIVE_FEATURE_GROUPS, ALL_ADMINISTRATIVE_FEATURES } from './administrative';
import { ALL_CRM_INTEGRATIONS_FEATURE_GROUPS, ALL_CRM_INTEGRATIONS_FEATURES } from './crm-integrations';
import { ALL_PAYMENTS_FEATURE_GROUPS, ALL_PAYMENTS_FEATURES } from './payments';
import { ALL_CRM_FEATURE_GROUPS, ALL_CRM_FEATURES } from './crm';
import { ALL_TICKETS_FEATURE_GROUPS, ALL_TICKETS_FEATURES } from './tickets';
import { ALL_MARKETING_FEATURE_GROUPS, ALL_MARKETING_FEATURES } from './marketing';

export const ALL_FEATURE_GROUPS: FeatureGroup[] = [
  ...ALL_ADMINISTRATIVE_FEATURE_GROUPS,
  ...ALL_CRM_INTEGRATIONS_FEATURE_GROUPS,
  ...ALL_PAYMENTS_FEATURE_GROUPS,
  ...ALL_CRM_FEATURE_GROUPS,
  ...ALL_TICKETS_FEATURE_GROUPS,
  ...ALL_MARKETING_FEATURE_GROUPS,
];

export const ALL_FEATURES: Feature[] = [
  ...ALL_ADMINISTRATIVE_FEATURES,
  ...ALL_CRM_INTEGRATIONS_FEATURES,
  ...ALL_PAYMENTS_FEATURES,
  ...ALL_CRM_FEATURES,
  ...ALL_TICKETS_FEATURES,
  ...ALL_MARKETING_FEATURES,
];

// Re-export the individual feature groups + module constants so apps can
// import them by name from '@socialgoodsoftware/frbac' (e.g.
// `CALENDAR_BUILDER_FEATURE_GROUP`, `SETTINGS_FEATURES`).
export * from './administrative';
export * from './crm-integrations';
export * from './payments';
export * from './crm';
export * from './tickets';
export * from './marketing';
